<template>
    <div class="invoice-details-type-1">
        <div class="left">
            <div class="icon-card-pos"></div>
        </div>
        <div class="right">
            <div class="name">{{account.invoice_name}}</div>

            <div class="address">
                <div class="value">
                    <div class="address-line-1" v-if="account.invoice_address">{{account.invoice_address}}</div>
                    <div class="address-line-2" v-if="account.invoice_postal_code || account.invoice_city">{{account.invoice_postal_code}}{{account.invoice_city ? ' ' + account.invoice_city : ''}}</div>
                    <div class="address-line-3" v-if="(account.invoice_country_code  && countryOptions[account.invoice_country_code]) || true">{{$t(countryOptions[account.invoice_country_code] || countryOptions['nl'])}}</div>
                </div>
            </div>
            <div class="invoice-email" v-if="account.invoice_email">
                <div class="h6">{{$t('common.invoice_email')}}</div>
                <div class="value">{{account.invoice_email}}</div>
            </div>
            <div class="vat" v-if="account.invoice_vat">
                <div class="h6">{{$t('common.vat')}}</div>
                <div class="value">{{account.invoice_vat}}</div>
            </div>
            <div class="po-number" v-if="account.invoice_po">
                <div class="h6">{{$t('common.po_number')}}</div>
                <div class="value">{{account.invoice_po}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useAccountStore } from '@/stores/account';

    export default {
        name: 'InvoiceDetails',
        data() {
            return {
                countryOptions: {
                    'nl': "fields.invoice_country.option_nl",
                    'be': "fields.invoice_country.option_be",
                    'de': "fields.invoice_country.option_de",
                    'fr': "fields.invoice_country.option_fr",
                    'lu': "fields.invoice_country.option_lu",
                    'at': "fields.invoice_country.option_at",
                    'ie': "fields.invoice_country.option_ie",
                    'pt': "fields.invoice_country.option_pt",
                    'dk': "fields.invoice_country.option_dk",
                    'es': "fields.invoice_country.option_es",
                    'fi': "fields.invoice_country.option_fi",
                    'it': "fields.invoice_country.option_it",
                    'gb': "fields.invoice_country.option_gb",
                    'se': "fields.invoice_country.option_se",
                }
            }
        },
        computed: {
            account() {
                return useAccountStore().account;
            }
        }
    }
</script>